import _ from 'lodash';
import React, { useContext } from 'react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './PrivacyDisclosure.metadata.json5';
import styles from './PrivacyDisclosure.module.scss';
import messages from './PrivacyDisclosure.messages';

/**
 * Depopulation Privacy Disclosure
 * US26480: PE - Depopulation - Agent Privacy Opt-in/Opt-out
 * @param {*} props 
 * @returns 
 */
function PrivacyDisclosure(props) {

    const { privacyOptOut_TWIA: privacyOptOutTWIA } = props;
    const translator = useContext(TranslatorContext);

    const overrideProps = {
        '@field': {},                
        privacyTextPart1: {
            content: translator(messages.privacyDisclosureTextPart1)
        },
        privacyTextPart2: {
            content: translator(messages.privacyDisclosureTextPart2)
        },
        privacyDisclosureOptOutDate: {
            visible: _.get(privacyOptOutTWIA, 'decision', false)
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return(
        <ViewModelForm
                uiProps={metadata.pageContent}
                model={privacyOptOutTWIA}
                overrideProps={overrideProps}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}                
            />         
    );
}

export default PrivacyDisclosure;
